/* @flow */
import { firebase } from '../system/Firebase';

export const auth = firebase.auth();

export default firebase;
